import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MobileNavBar.css";
import { getStoredData } from "../../api/fetchData.jsx";

const MobileNavBar = ({ navData, logo }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const toggleMenu = () => {
    if (isMenuOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsMenuOpen(false);
        setIsClosing(false);
      }, 300); // Match CSS animation duration
    } else {
      setIsMenuOpen(true);
    }
  };

  const data = getStoredData();
  const totalData = data[0];

  return (
    <div className="mobile-nav">
      <div className="mobile-header">
        {logo && (
          <Link to="/">
            <img
              src={totalData?.CompanyLogo}
              alt="Logo"
              className="mobile-logo"
            />
          </Link>
        )}
        <div className="mobile-menu-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {isMenuOpen && (
        <div className={`mobile-menu ${isClosing ? "closing" : ""}`}>
          <button className="close-menu-btn" onClick={toggleMenu}>
            &times;
          </button>
          <ul>
            {navData.map((item, index) => (
              <li key={index}>
                {item.link.startsWith("http") ? (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={toggleMenu}
                  >
                    <i className={`fas ${item.icon} MobileMenu-icon`}></i>
                    <span>{item.name}</span>
                  </a>
                ) : (
                  <Link to={item.link} onClick={toggleMenu}>
                    <i className={`fas ${item.icon} MobileMenu-icon`}></i>
                    <span>{item.name}</span>
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MobileNavBar;
